module.exports = __webpack_public_path__ + "img/m-icon4.e257bdd1.png";